import React from 'react';
import { BackIcon, MyButton } from './styles';

interface IGoBackButtonProps {
  title: string;
  onClick(): void;
}

const GoBackButton: React.FC<IGoBackButtonProps> = ({ title, onClick }) => {
  return (
    <MyButton onClick={onClick}>
      <BackIcon />
      <span>{title}</span>
    </MyButton>
  );
};

export default GoBackButton;
